import React, { Component } from "react";
import { InputAdornment } from "@material-ui/core";
import ConfirmationNumberOutlinedIcon from "@material-ui/icons/ConfirmationNumberOutlined";
import LpField from "../lp-field/lp-field";

class VoucherInput extends Component {
  constructor(props) {
    super(props);
    this.state = { touched: false };
  }

  formatUuid(raw) {
    const clean = raw.replace(/[^0-9A-Fa-f]/g, "").toUpperCase().slice(0, 32);
    const parts = [clean.slice(0, 8), clean.slice(8, 12), clean.slice(12, 16), clean.slice(16, 20), clean.slice(20, 32)];
    return parts.filter(Boolean).join("-");
  }

  getCleanLength() {
    return (this.props.value || "").replace(/-/g, "").length;
  }

  handleChange = (event) => {
    const formatted = this.formatUuid(event.target.value);
    if (formatted.replace(/-/g, "").length > 0) {
      this.setState({ touched: false });
    }
    if (this.props.onChange) {
      this.props.onChange(formatted);
    }
  };

  handleBlur = () => {
    this.setState({ touched: true });
    if (this.props.onBlur) {
      this.props.onBlur();
    }
  };

  render() {
    const { label, disabled, id, value } = this.props;
    const cleanLen = this.getCleanLength();
    const isIncomplete = cleanLen > 0 && cleanLen < 32;
    const isComplete = cleanLen === 32;
    const showError = this.state.touched && isIncomplete;

    let helperText = "Insira o código do voucher conforme recebido";
    if (showError) {
      helperText = "Código incompleto — preencha todos os caracteres";
    } else if (isComplete) {
      helperText = "";
    }

    return (
      <LpField
        id={id}
        label={label}
        autoComplete="off"
        value={value || ""}
        onChange={this.handleChange}
        onBlur={this.handleBlur}
        disabled={disabled}
        placeholder="XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX"
        helperText={helperText}
        error={showError}
        inputProps={{
          maxLength: 36,
          autoComplete: "off",
          "aria-label": "Código do voucher Pacto",
        }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <ConfirmationNumberOutlinedIcon style={{ color: showError ? "#f44336" : "rgba(0, 0, 0, 0.38)" }} />
            </InputAdornment>
          ),
        }}
        fullWidth
      />
    );
  }
}

export default VoucherInput;
